import React, { Component } from 'react'
import { follow, unfollow } from './apiUser';

class FollowProfileButton extends Component {

    followClick = () => {
        this.props.onButtonClick(follow);
    }

    unfollowClick = () => {
        this.props.onButtonClick(unfollow);
    }

    componentDidMount() {
        //document.getElementById('follow_buttons').style.visibility = 'visible';
    }



    render() {
        //let lFollow = this.props.following;
        return (
            <div id="follow_buttons" className="d-inline-block">
                {
                    !this.props.following ? (
                        <button onClick={this.followClick} className="btn btn-raised btn-success mr-5">Follow</button>
                    ) : (
                            <button onClick={this.unfollowClick} className="btn btn-raised btn-warning">UnFollow</button>
                        )
                }
            </div>
        );
    };
}

export default FollowProfileButton;


/*                 <button onClick={lFollow ? this.followClick : this.unfollowClick} className={"btn btn-raised mr-5 " + (lFollow ? 'btn-warning' : 'btn-success')}>
    {lFollow ? 'Unfollow' : 'Follow'}
</button> */